<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="main-toolbar cf-flex-row cf-justify-content-end" color="primary">
  <div class="left-side">
    <span class="title">{{ projectName }}: {{ 'UI.Common.Text.LineEditor' | translate }}</span>
  </div>
</mat-toolbar>
<div class="main-content-with-sidebar">
  <div *ngIf="showLoading$ | async" class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <div *ngIf="(showLoading$ | async) === false">
    <div *ngIf="projectEntity$ | async as projectEntity">
      <mat-sidenav-container autosize class="product-drawer-container">
        <mat-sidenav
          *ngIf="showInSidebar"
          class="right"
          [ngClass]="{ opened: (sidebarRightOpened$ | async), closed: (sidebarRightOpened$ | async) === false }"
          mode="side"
          position="end"
          opened="true"
          [ngStyle]="{ 'max-height': sidenavSettings.height + 'px' }"
          [fixedInViewport]="sidenavSettings.fixed"
          [fixedTopGap]="sidenavSettings.top"
          [fixedBottomGap]="sidenavSettings.bottom"
          disableClose="true"
        >
          <div
            *ngIf="show3DStatus$ | async as status"
            class="cf-flex-column sidebar-content"
            [ngStyle]="{ 'padding-bottom': visualEditorPadding + 'px' }"
          >
            <div class="visual-editor-wrapper">
              <app-product-visual-editor
                *ngIf="status.show3d"
                [projectEntity]="projectEntity"
                [isHoodline]="true"
                [enableDragAndDrop]="true"
                [errorHighlightIds]="panelErrorIds$ | async"
                (entityClicked)="entity3DClicked($event)"
                (objectMoved)="editorUpdate($event)"
              >
              </app-product-visual-editor>
              <div *ngIf="!status.show3d" class="no-3d">
                <p>{{ status.noShowReasonTextId | translate }}</p>
              </div>
            </div>
            <app-hoodline-messages
              #messageBox
              *ngIf="sidebarRightOpened$ | async"
              [messageFilter]="isHoodLineMessage"
              [overlapMessages]="overlapMessages$ | async"
              [hoodlines]="getHoodlines(projectEntity$ | async)"
            ></app-hoodline-messages>
          </div>
        </mat-sidenav>

        <div class="product-content">
          <mat-expansion-panel
            [expanded]="hoodSettingsOpened$ | async"
            (opened)="toggleHoodSettings(true)"
            (closed)="toggleHoodSettings(false)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="hood-title">
                <b>{{ 'UI.Common.ConfigureHoodLinesTitle' | translate }}</b>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>
              <app-product-editor [projectEntity]="projectEntity" [groupFilter]="shouldRenderGroupFilter"></app-product-editor>
            </p>
          </mat-expansion-panel>

          <app-hood-data-form [projectEntity]="projectEntity"></app-hood-data-form>

          <app-hoodline [projectEntity]="projectEntity"></app-hoodline>

          <div *ngIf="!showInSidebar">
            <app-product-visual-editor
              *ngIf="(show3DStatus$ | async).show3d"
              [projectEntity]="projectEntity"
              [isHoodline]="true"
              [enableDragAndDrop]="true"
              [errorHighlightIds]="panelErrorIds$ | async"
              (entityClicked)="entity3DClicked($event)"
            ></app-product-visual-editor>
          </div>
        </div>
        <div class="container">
          <app-product-editor [projectEntity]="projectEntity" [groupFilter]="shouldRenderButtonGroup"></app-product-editor>
          <button mat-flat-button color="primary" class="add-line-button" (click)="addLine()">
            {{ 'GastroFlowHood.AddLine' | translate }}
          </button>
          <button
            *ngIf="getHoodVersion(projectEntity) > 1"
            mat-flat-button
            color="primary"
            class="add-line-button"
            (click)="addConnectionLine()"
          >
            {{ 'GastroFlowHood.AddConnectionLine' | translate }}
          </button>
        </div>
      </mat-sidenav-container>
    </div>
  </div>
</div>
